import { render, staticRenderFns } from "./referralOrdersList.vue?vue&type=template&id=d50bbf06&scoped=true&"
import script from "./referralOrdersList.vue?vue&type=script&lang=js&"
export * from "./referralOrdersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d50bbf06",
  null
  
)

export default component.exports